import { capitalize } from "lodash";
import { NextSeo } from "next-seo";
import Head from "next/head";

export function MetaHead({ title, description, url, image }: any) {
  return (
    <>
      <Head>
        <link rel="icon" type="image/x-icon" href="/icons/favicon.ico?" />
        <meta name="theme-color" content="#000" />
      </Head>
      <NextSeo
        title={capitalize(title)}
        description={capitalize(description)}
        canonical={url}
        openGraph={{
          url,
          title,
          description,
          images: [{ url: image }],
          siteName: title,
        }}
      />
    </>
  );
}
